// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getForgetPassApi } from "../../services/Api/ForgetPasswordApi"
import { getErrors, getForgetPassMessageSuccess, getUserNewPhone } from "../reducers/ForgetPasswordReducer"
import { getUserPhone } from "../reducers/userInfoReducer"


// Watchers
function* forgetPasswordSaga() {
	yield takeEvery("forget_password/getForgetPassMessage", getForgetPass)
}

// Sagas
function* getForgetPass(action) {
	// console.log(action.payload, "saga payload")
    yield put(getUserPhone(action.payload))
    yield put(getUserNewPhone(action.payload))
    	
	try {
		const data = yield call(getForgetPassApi, action.payload)
		// console.log(data, "resend saga response")

		if (data.request.status == 200) {
            yield put(getForgetPassMessageSuccess(data))
            // not copied into the sign-up OTP state any more: the reset page has its own OTP
            // field, and a stale status 200 there made the sign-up OTP page jump to login

		} else {
			yield put(getErrors(data.response.data))
		 
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(forgetPasswordSaga)])
}
